import StarIcon from '@mui/icons-material/Star';
import StarHalfOutlinedIcon from '@mui/icons-material/StarHalfOutlined';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import classNames from 'classnames';
import React from 'react';

type Props = {
  scores: number[];
  showNumberOfReviews?: boolean;
};

const MStar = () => <StarIcon fontSize="small" style={{ fill: '#141414' }} />;

const MStarOutlineIcon = () => (
  <StarOutlineIcon fontSize="small" style={{ fill: 'var(--color-gray)' }} />
);

const MStarHalfOutlinedIcon = () => (
  <StarHalfOutlinedIcon fontSize="small" style={{ fill: '#141414' }} />
);

export const StarRating: React.FC<Props> = ({
  scores,
  showNumberOfReviews = true,
}): JSX.Element => {
  // calculate average score
  const averageScore = scores.reduce((a, b) => a + b, 0) / scores.length;
  // round averageScore to nearest 0.5
  const roundedAverageScore = Math.round(averageScore * 2) / 2;

  let starsIcons;
  switch (roundedAverageScore) {
    case 0:
      starsIcons = (
        <>
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 0.5:
      starsIcons = (
        <>
          <MStarHalfOutlinedIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 1:
      starsIcons = (
        <>
          <MStar />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 1.5:
      starsIcons = (
        <>
          <MStar />
          <MStarHalfOutlinedIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 2:
      starsIcons = (
        <>
          <MStar /> <MStar />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 2.5:
      starsIcons = (
        <>
          <MStar />
          <MStar />
          <MStarHalfOutlinedIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 3:
      starsIcons = (
        <>
          <MStar />
          <MStar />
          <MStar />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 3.5:
      starsIcons = (
        <>
          <MStar />
          <MStar />
          <MStar />
          <MStarHalfOutlinedIcon />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 4:
      starsIcons = (
        <>
          <MStar />
          <MStar />
          <MStar />
          <MStar />
          <MStarOutlineIcon />
        </>
      );
      break;
    case 4.5:
      starsIcons = (
        <>
          <MStar />
          <MStar />
          <MStar />
          <MStar />
          <MStarHalfOutlinedIcon />
        </>
      );
      break;
    case 5:
      starsIcons = (
        <>
          <MStar />
          <MStar />
          <MStar />
          <MStar />
          <MStar />
        </>
      );
      break;
    default:
      starsIcons = (
        <>
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
          <MStarOutlineIcon />
        </>
      );
  }

  return (
    <>
      {showNumberOfReviews ? (
        <div className={'mb-4'}>
          <a
            href="#reviews"
            className={classNames('link-secondary flex items-center', {
              'justify-center md:justify-start': showNumberOfReviews,
            })}
            onClick={(e) => {
              e.preventDefault();
              // prettier-ignore
              const reviews: HTMLDivElement = document.querySelector('#reviews');
              const navbar: HTMLDivElement = document.querySelector('#navbar');

              if (reviews && navbar) {
                window.scrollTo({
                  top: reviews.offsetTop - (navbar.clientHeight + 16),
                  behavior: 'smooth',
                });
              }
            }}
          >
            {starsIcons}

            <span className=" ml-2 text-sm leading-none">
              {scores.length} {scores.length === 1 ? 'review' : 'reviews'}
            </span>
          </a>
        </div>
      ) : (
        <div className={classNames({ 'justify-center': showNumberOfReviews })}>
          {starsIcons}
        </div>
      )}
    </>
  );
};
